module.exports = __webpack_public_path__ + "img/vertical_5_1_3016.071bca72.png";